import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';

const Overline = styled(Typography)({
    fontWeight: '500 !important',
    fontSize: '10px !important',
    lineHeight: '12px !important',
    letterSpacing: '1.5px !important',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
    display: 'block',
});

export default Overline;
